<template>
	<div class="container">
		<div class="creator creator--account">
			<div class="left">
				<router-link class="creator__link" to="/creator/">{{$t('title.items')}}</router-link>
				<router-link class="creator__link selected" to="/account/">{{$t('title.account')}}</router-link>
			</div>
			<div class="right">
				<div class="account__settings">
					<div class="settings__group">
						<h2>{{$t('title.account')}}</h2>
						<div class="settings__entry">
							<label for="display_name">{{$t('page.account.displayname')}}*</label>
							<input v-model="userData.text" id="display_name" name="display_name" type="text" />
						</div>
						<div class="settings__entry">
							<label for="email">{{$t('page.account.contact_email')}}*</label>
							<input v-model="userData.email" id="email" name="email" type="text" />
						</div>
						<div class="settings__entry">
							<label for="phone">{{$t('page.account.contact_phone')}}</label>
							<input v-model="userData.phone" id="phone" name="phone" type="text" />
						</div>
						<div class="settings__entry">
							<label for="website">{{$t('page.account.website')}}</label>
							<input placeholder="https://www.loxone.com" v-model="userData.website" id="website" name="website" type="url" />
						</div>
					</div>
					<div class="settings__group">
						<h2>{{$t('page.account.user_info')}}</h2>
						<div class="settings__entry">
							<label for="name">{{$t('page.account.user_name')}}*</label>
							<input v-model="userData.name" id="name" name="name" type="text" />
						</div>
						<div class="settings__entry">
							<br/>
							<a href="https://www.loxone.com/int/login/?redirect=https://www.loxone.com/int/id/my-data/">Change Password</a>
						</div>
						<div class="settings__entry">
							<label for="image">{{$t('page.account.user_image')}}*</label>
							<div class="preview--box">
								<plugin-logo v-if="userData.image" :size="128" :type="'image'" :path="'https://api.library.loxone.com' + userData.image"></plugin-logo>
								<plugin-logo v-else :size="128" :type="'image'" :path="'https://api.library.loxone.com/files/global/user.png'"></plugin-logo>
								<div class="preview--edit">
									<btn @click="toggleWrapper" :class="'btn--ghost'" :text="$t('page.listing.icon_btn')" />
									<div v-if="showWrapper" class="image__wrapper">
										<label for="logo" class="background">
											<label for="logo" class="button">{{$t('page.creator.upload_select')}}</label>
										</label>
										<input accept="image/*" @change="changeImage()" type="file" id="logo" name="logo" ref="logo" />
									</div>
								</div>
							</div>
							<div class="preview--image">
							</div>
						</div>
					</div>
					<div v-if="userData.notifications && !userData.notifications" class="settings__group">
						<h2>{{$t('page.account.notifications')}}</h2>
						<input @click="toggleNotifications" v-if="!userData.notifications" type="checkbox" id="notifications" name="notifications">
						<div @click="toggleNotifications" v-else class="fake__checkbox"><svg style="vertical-align:top;" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" data-v-5d880b3b=""><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" fill="#FFFFFF" data-v-5d880b3b=""></path></svg></div>
						<label @click="toggleNotifications">{{$t('page.account.notification_txt')}}</label>
					</div>
					<btn :class="'btn--save'" @click="updateAccount" :text="$t('page.listing.save')" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
    import Btn from '../components/Button.vue';
    import PluginLogo from '../components/PluginLogo.vue';

export default {
	components: {
		Btn,
		PluginLogo,
	},
	data() {
		return {
			userData: {
				text: '',
				email: '',
				phone: '',
				website: '',
				notifications: false,
				name: '',
				image: '',
			},
			showWrapper: false
		}
	},
	methods: {
		changeImage() {
			var pluginInfo = new FormData();
			for( var i = 0; i < this.$refs.logo.files.length; i++ ){
				let file = this.$refs.logo.files[i];
				pluginInfo.append('files[' + i + ']', file);
			}

			axios({
					method: 'post',
					crossDomain: true,
					withCredentials: true,
					url: 'https://api.library.loxone.com/updateUserLogo',
					data: pluginInfo,
				}).then(response => {
					this.userData.image = response.data.image;
				});

			this.showWrapper = false;
		},
		toggleWrapper() {
			this.showWrapper = !this.showWrapper;
		},
		toggleNotifications() {
			this.userData.notifications = !this.userData.notifications;
		},
		updateAccount() {
			if(this.userData.website != "" && !this.userData.website.includes('https://') && !this.userData.website.includes('http://')) {
					this.$store.dispatch('addNotification', {title: this.$t('notification.error'), text: this.$t('notification.account_update_website_txt'), type: 'error'});
			} else {
				var userDataInfo = new FormData();
				userDataInfo.append('userData', JSON.stringify(this.userData));
				axios({
					method: 'post',
					crossDomain: true,
					withCredentials: true,
					data: userDataInfo,
					url: 'https://api.library.loxone.com/updateAccount'
				}).then(() => {
					this.$store.dispatch('addNotification', {title: this.$t('notification.account_update_successfull'), text: this.$t('notification.account_update_successfull_txt'), type: 'success'});
				});
			}
		}
	},
	created() {
		axios({
			method: 'post',
			crossDomain: true,
			withCredentials: true,
			url: 'https://api.library.loxone.com/loadAccountDetail'
		}).then(response => (this.userData = response.data));
	}
}
</script>

<style scoped lang="scss">
	input[type="checkbox"] {
		width: 16px;
		height: 16px;
		border: 1px solid #979797;
		background-color: rgba(255, 255, 255, 0.7);
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		outline: none;
		margin: 0;
		vertical-align: middle;
		cursor: pointer;
		margin-right: 10px;
		vertical-align: top;
		margin-top: 2px;
	}
	.fake__checkbox{
		background-color: #575C61;
		width: 16px;
		height: 16px;
		display: inline-block;
		vertical-align: middle;
		padding: 2px;
		box-sizing: border-box;
		border: 1px solid #979797;
		margin-right: 10px;
		vertical-align: top;
		margin-top: 2px;
	}
	.settings__group:first-child{
		padding-top: 0;
	}
	.settings__group:first-child label{
		margin: 0;
	}

	.settings__entry > label{
		font-size: 14px;
		font-weight: bold;
		line-height: 20px;
		display: block;
		margin-top: 25px !important;
	}
	span.description{
		display: block;
		color: #575C61;
		font-size: 14px;
		line-height: 20px;
	}
	.settings__entry input{
		border: 1px solid #BBBBBB;
		min-width:320px;
		padding: 0 15px;
		line-height: 48px;
		outline: none;
		font-size: 16px;
		margin-top: 10px;
	}

	.settings__group{
		padding-bottom: 40px;
		padding-top: 30px;
		border-bottom: 1px solid #BBBBBB;
	}
	.creator{
		background-color: #FAFAFA;
		height: 100%;
	}
	.container{
		height: 100%;
	}
	.left{
		width: 240px;
		display: inline-block;
		background-color: #F4F4F4;
		padding: 55px 25px 50px 0;
		box-sizing: border-box;
		height: 100%;
	}

	.right{
		width: calc(100% - 240px);
		padding: 40px 25px;
		display: inline-block;
		box-sizing: border-box;
		vertical-align: top;
		height: 100%;
	}
	
	h1{
		font-size: 30px;
		line-height: 40px;
		color: #000A12;
		font-weight: normal;
		vertical-align: middle;
		margin: 0;
	}
	.account__header{
		display: flex;
		justify-content: space-between;
		padding-bottom: 45px;
	}

	
    @import '../scss/utilities/variables';
    @import '../scss/pages/creator';
</style>
